import { useEffect, useState } from "react";
import { Search, SlidersHorizontal, Users } from "lucide-react";
import { Navbar, Footer } from "@/components/Navbar";
import { ProfessionalCard } from "@/components/Cards";
import api from "@/lib/api";

export default function Directory() {
  const [meta, setMeta] = useState({ sectors: [], cities: [], regions: [] });
  const [pros, setPros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ sector: "", city: "", region: "", q: "" });

  useEffect(() => { api.get("/meta").then((r) => setMeta(r.data)); }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
    api.get("/professionals", { params }).then((r) => setPros(r.data)).finally(() => setLoading(false));
  }, [filters]);

  const Select = ({ field, label, options }) => (
    <div>
      <label className="text-sm font-medium text-[#1c1917]">{label}</label>
      <select
        data-testid={`filter-${field}`}
        value={filters[field]}
        onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
        className="w-full mt-1.5 bg-white border border-[#e7e5e4] rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20 focus:border-[#1b5e3f]"
      >
        <option value="">Todos</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-xl bg-[#e8f0ec] flex items-center justify-center"><Users className="w-5 h-5 text-[#1b5e3f]" /></span>
          <div>
            <h1 className="font-head text-2xl sm:text-3xl font-semibold text-[#1c1917]">Busque por profissionais</h1>
            <p className="text-[#78716c] text-sm">Encontre serviços por ramo de atividade, cidade e região.</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-4 gap-8 mt-8">
          <aside className="lg:col-span-1">
            <div className="bg-white rounded-2xl border border-[#e7e5e4] shadow-sm p-6 lg:sticky lg:top-24 space-y-5">
              <div className="flex items-center gap-2 text-[#1c1917] font-head font-semibold"><SlidersHorizontal className="w-4 h-4" /> Filtros</div>
              <div>
                <label className="text-sm font-medium text-[#1c1917]">Buscar</label>
                <div className="relative mt-1.5">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#78716c]" />
                  <input data-testid="filter-search" value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} placeholder="Nome ou serviço" className="w-full bg-white border border-[#e7e5e4] rounded-xl pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b5e3f]/20 focus:border-[#1b5e3f]" />
                </div>
              </div>
              <Select field="sector" label="Setor / Ramo" options={meta.sectors} />
              <Select field="city" label="Cidade" options={meta.cities} />
              <Select field="region" label="Região" options={meta.regions} />
              <button data-testid="filter-clear" onClick={() => setFilters({ sector: "", city: "", region: "", q: "" })} className="text-sm text-[#78716c] hover:text-[#1b5e3f] underline">Limpar filtros</button>
            </div>
          </aside>

          <main className="lg:col-span-3">
            {loading ? (
              <div className="grid sm:grid-cols-2 gap-6">
                {[1, 2, 3, 4].map((i) => <div key={i} className="h-48 rounded-2xl bg-[#e7e5e4]/40 animate-pulse" />)}
              </div>
            ) : pros.length === 0 ? (
              <div className="bg-white rounded-2xl border border-[#e7e5e4] p-12 text-center">
                <p className="text-[#78716c]">Nenhum profissional encontrado com esses filtros.</p>
              </div>
            ) : (
              <>
                <p className="text-sm text-[#78716c] mb-4">{pros.length} profissional(is) encontrado(s)</p>
                <div className="grid sm:grid-cols-2 gap-6">
                  {pros.map((p) => <ProfessionalCard key={p.id} p={p} />)}
                </div>
              </>
            )}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
